import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import io from 'socket.io-client';
import preview_image from '../../assets/archived-instant-preview.png';
import { DateUtils, StringUtils } from '../../utils';

import { Routes as routes, History as history } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, InstantActions } from '../../actions';
import { TitleBar, NavBar, Line, AuthCheck, SingleScreenNavBar } from  '../../components'

class InstantCompletedScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_status: 'COMPLETED',
    }
    this.socket = null;
  }

  componentDidMount() {
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let page_state  = this.props.instant && this.props.instant.instantPageState ? this.props.instant.instantPageState : { page_number: 1, status: 'COMPLETED' };
    let practice_id = this.props.practice && this.props.practice.practice && this.props.practice.practice._id ? this.props.practice.practice._id : '';

    if (token) {
      this.props.instantActions.getCompletedSessions(token, practice_id);
    }
    this.updatePageState();
    this.setState({ ...this.state, selected_status: page_state.status })
  }

  componentDidUpdate() {
    let practice_id        = this.props.instant && this.props.instant.instantUserPractice && this.props.instant.instantUserPractice._id ? this.props.instant.instantUserPractice._id : '';
    let already_subscribed = this.state.subscribed_to_socket;
    if (!already_subscribed && practice_id) {
      this.socket = io(config.NOTIF_URL, { path: '/notifications', query: `notification=${practice_id}` });
      this.socket.on('INSTANT', (notification) => {
        if (notification.instantSession) {
          let updatedSession = notification.instantSession;
          if (updatedSession) {
            this.props.instantActions.updateSession(updatedSession);
          }
        }
      });
      this.setState({ ...this.state, subscribed_to_socket: true });
    }
  }

  renderStatusTabs = () => {
    let selected_status  = this.state.selected_status;
    let com_border_color = selected_status === 'COMPLETED' ? '#1dc2ff' : 'white';
    let can_border_color = selected_status === 'CANCELLED' ? '#1dc2ff' : 'white';
    let com_title_color  = selected_status === 'COMPLETED' ? '#1dc2ff' : '#575757';
    let can_title_color  = selected_status === 'CANCELLED' ? '#1dc2ff' : '#575757';
    return <div className='flex-container-row'>
      <div className='flex-container-column' style={{ height: 45 }}
           onClick={ () => {
             this.updatePageState(1, 'COMPLETED');
             this.setState({ ...this.state, selected_status: 'COMPLETED' })
           }}>
        <span />
        <div className='flex-container-column instant-completed-tab-buttons' style={{ flex: 1, justifyContent: 'center', paddingLeft: 20, paddingRight: 20, fontSize: 14, color: com_title_color }}>
          <span><span className='fas fa-check' style={{ marginRight: 5 }}/>Completed</span>
        </div>
        <div style={{ height: 2, backgroundColor: com_border_color }}></div>
      </div>
      <div className='flex-container-column' style={{ height: 45 }}
           onClick={ () => {
             this.updatePageState(1, 'CANCELLED');
             this.setState({ ...this.state, selected_status: 'CANCELLED' })
           }}>
        <span />
        <div className='flex-container-column instant-completed-tab-buttons' style={{ flex: 1, justifyContent: 'center', paddingLeft: 20, paddingRight: 20, fontSize: 14, color: can_title_color }}>
          <span><span className='fas fa-times' style={{ marginRight: 5 }}/>Cancelled</span>
        </div>
        <div style={{ height: 2, backgroundColor: can_border_color }}></div>
      </div>
    </div>
  }

  renderLabelRow = () => {
    let completed_canceled = this.state.selected_status === 'COMPLETED' ? 'COMPLETED' : 'CANCELLED';
    return <div className='flex-container-row' style={{ padding: 5, paddingLeft: 15, paddingRight: 10 }}>
      <div style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 1 }}>CLIENT</div>
      <div style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 1 }}></div>
      <div style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 0.8 }}>INVITED</div>
      <div style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 0.8 }}>{ completed_canceled }</div>
      { this.state.selected_status === 'COMPLETED' ? <div style={{ width: 35 }}></div> : null  }
      <div style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 0.8 }}></div>
    </div>
  }

  renderLabel = (status) => {
    if (status === 'COMPLETED') {
      return <div className='flex-container-row' style={{ padding: 3, width: 100, backgroundColor: '#e8f8ff', justifyContent: 'center', alignItems: 'center', borderRadius: 20 }}>
        <span className='fas fa-check' style={{ color: '#1dc2ff', fontSize: 11 }} />
        <span style={{ fontSize: 11, marginLeft: 5, color: '#1dc2ff', marginTop: 2 }}>Completed</span>
      </div>
    }
    if (status === 'CANCELLED') {
      return <div className='flex-container-row' style={{ padding: 3, width: 100, backgroundColor: '#e8f8ff', justifyContent: 'center', alignItems: 'center', borderRadius: 20 }}>
        <span className='fas fa-times' style={{ color: '#1dc2ff', fontSize: 11 }} />
        <span style={{ fontSize: 11, marginLeft: 5, color: '#1dc2ff', marginTop: 2 }}>Cancelled</span>
      </div>
    }
  }

  renderCompletedRow = (session) => {
    let client_name   = session.client_name;
    let phone_number  = StringUtils.displayCodePhoneNumber(session.client_phone);
    let provider_name = session.provider_name || '';
    let location_name = session.location_name ;

    let invited_date   = DateUtils.getLongMonth(session.created_at) + ' ' + DateUtils.getDateNumber(session.created_at) + ', ' + DateUtils.getYear(session.created_at);
    let invited_time   = DateUtils.getTime(session.created_at);
    let completed_date = DateUtils.getLongMonth(session.completed_at) + ' ' + DateUtils.getDateNumber(session.completed_at) + ', ' + DateUtils.getYear(session.completed_at);
    let completed_time = DateUtils.getTime(session.completed_at);

    client_name   = client_name.length > 22    ? client_name.substr(0, 22)   + '..' : client_name;
    provider_name = provider_name.length > 22  ? provider_name.substr(0, 22) + '..' : provider_name;
    location_name = location_name.length > 22  ? location_name.substr(0, 22) + '..' : location_name;

    return <div className='flex-container-row' style={{ padding: 10, paddingLeft: 15 }}>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 1 }}>
        <span style={{ color: '#575757', fontWeight: 'bold' }}>{ client_name  }</span>
        <span>{ phone_number }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 1, justifyContent: 'flex-end' }}>
        <span>{ provider_name }</span>
        <span>{ location_name }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 0.8, justifyContent: 'flex-end' }}>
        <span>{ invited_date }</span>
        <span>{ invited_time }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 0.8, justifyContent: 'flex-end' }}>
        <span>{ completed_date }</span>
        <span>{ completed_time }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, width: 35, justifyContent: 'center' }}>
        <span className='instant-cancel-button'
              onClick={ () => {
                const screen_props = {
                  session: session
                }
                history.push({ pathname: routes.INSTANT_RECORDINGS, state: { props: screen_props } })
              }}>
              <span className='fas fa-play-circle' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <div className='flex-container-column' style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 0.8, alignItems: 'flex-end', justifyContent: 'center' }}>
        { this.renderLabel('COMPLETED') }
      </div>
    </div>
  }

  renderCancelledRow = (session) => {
    let client_name   = session.client_name;
    let phone_number  = StringUtils.displayCodePhoneNumber(session.client_phone);
    let provider_name = session.provider_name || '';
    let location_name = session.location_name ;

    let invited_date   = DateUtils.getLongMonth(session.created_at) + ' ' + DateUtils.getDateNumber(session.created_at) + ', ' + DateUtils.getYear(session.created_at);
    let invited_time   = DateUtils.getTime(session.created_at);
    let completed_date = DateUtils.getLongMonth(session.completed_at) + ' ' + DateUtils.getDateNumber(session.completed_at) + ', ' + DateUtils.getYear(session.completed_at);
    let completed_time = DateUtils.getTime(session.completed_at);

    client_name   = client_name.length > 22    ? client_name.substr(0, 22)   + '..' : client_name;
    provider_name = provider_name.length > 22  ? provider_name.substr(0, 22) + '..' : provider_name;
    location_name = location_name.length > 22  ? location_name.substr(0, 22) + '..' : location_name;

    return <div className='flex-container-row' style={{ padding: 10, paddingLeft: 15 }}>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 1 }}>
        <span style={{ color: '#575757', fontWeight: 'bold' }}>{ client_name  }</span>
        <span>{ phone_number }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 1, justifyContent: 'flex-end' }}>
        <span>{ provider_name }</span>
        <span>{ location_name }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 0.8, justifyContent: 'flex-end' }}>
        <span>{ invited_date }</span>
        <span>{ invited_time }</span>
      </div>
      <div className='flex-container-column' style={{ color: 'grey', fontSize: 12, flex: 0.8, justifyContent: 'flex-end' }}>
        <span>{ completed_date }</span>
        <span>{ completed_time }</span>
      </div>
      <div className='flex-container-column' style={{ color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', flex: 0.8, alignItems: 'flex-end', justifyContent: 'center' }}>
        { this.renderLabel('CANCELLED') }
      </div>
    </div>
  }

  renderSessionRows = () => {
    let selected_status = this.state.selected_status;
    let display_data    = this.getSessionsToDisplay();
    let sessions        = display_data.sessions;
    let session_rows    = [];

    if (selected_status === 'COMPLETED') {
      session_rows = sessions.map((session) => {
        return <div className='flex-container-column' key={session._id}>{ this.renderCompletedRow(session) }<Line style={{ backgroundColor: '#f5f5f5' }} /></div>
      }).filter((row) => { return row });
    }

    if (selected_status === 'CANCELLED') {
      session_rows = sessions.map((session) => {
        return <div className='flex-container-column' key={session._id}>{ this.renderCancelledRow(session) }<Line style={{ backgroundColor: '#f5f5f5' }} /></div>
      }).filter((row) => { return row });
    }

    let display_no_session = session_rows.length === 0 ? true : false;

    return <div>
      { display_no_session ? <div style={{ textAlign: 'center', fontSize: 14, color: 'grey', marginTop: 35, marginBottom: 35 }}>There are no sessions to display</div> : session_rows }
      { display_no_session ? null : this.renderFooterRow(display_data.display_next, display_data.display_prev) }
    </div>
  }

  renderFooterRow = (display_next, display_prev) => {
    let page_state = this.props.instant && this.props.instant.instantPageState ? this.props.instant.instantPageState : { page_number: 1, status: 'COMPLETED' };
    let page_numb  = page_state.page_number;
    if (display_prev || display_next) {
      return <div className='flex-container-row' style={{ padding: 10, justifyContent: 'flex-end', alignItems: 'center' }}>
        { display_prev ? <div className='header-button' style={{ marginRight: 0 }} onClick={ () => { this.updatePageState(page_numb - 1) }}>Prev</div> : null }
        <span style={{ marginRight: 10, marginLeft: 10, fontSize: 15, color: '#575757' }}>{ page_numb }</span>
        { display_next ? <div className='header-button' onClick={ () => { this.updatePageState(page_numb + 1) }}>Next</div> : null }
      </div>
    }
  }

  renderCompletedSection = () => {
    return <div className='instant-completed-container'>
      { this.renderStatusTabs()  }
      <Line />
      { this.renderLabelRow()    }
      <Line />
      { this.renderSessionRows() }
    </div>
  }

  renderUpgradeMessage = () => {

    return <div className='instant-completed-container' style={{ padding: 15, maxWidth: 700, width: 700 }}>
      <div className='flex-container-column' style={{ alignItems: 'center' }}>
        <span style={{ fontWeight: 'bold', fontSize: 14, letterSpacing: 0.4, marginTop: 2, color: '#575757' }}>Available only to Instant+, Professional and Enterprise plans</span>
        <div style={{ height: 2, backgroundColor: '#1dc2ff', width: 465, borderRadius: 10, marginTop: 5, marginBottom: 3 }}></div>
        <span style={{ fontSize: 13, letterSpacing: 0.4, color: '#1dc2ff' }}>Securely archive and access completed sessions for records and continuity.</span>
        <div className='instant-join-session-button'
             style={{ marginTop: 10, borderRadius: 30, paddingRight: 40, paddingLeft: 40 }}
             onClick={ () => {
               let screen_props = {
                 is_updgrade: true,
               }
               history.push({ pathname: routes.PRACTICE_PLANS, state: { props: screen_props } })
             }}>
          <span style={{ fontWeight: 'bold', fontSize: 14 }}>Upgrade</span>
        </div>
        <img className="instant-completed-preview-image" src={preview_image} alt="Icon Text" />
      </div>
    </div>
  }

  renderContentContainers = () => {
    let display_archived = this.displayArchivedSessions();

    if (display_archived) {
      return <div className="flex-container screen-main-content">
        { this.renderCompletedSection() }
      </div>
    } else {
      return <div className="flex-container screen-main-content">
        { this.renderUpgradeMessage() }
      </div>
    }
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <AuthCheck user={this.props.user} userActions={this.props.userActions} />
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Archives" />
        { this.renderContentContainers() }
      </div>
    );
  }

  displayArchivedSessions = () => {
    let practice        = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};
    let subscription    = practice && practice.subscription ? practice.subscription : {};
    let is_instant_paid = subscription.subscription_type === 'INSTANT_PAID';
    let is_core         = subscription.subscription_type === 'CORE';
    let is_enterprise   = subscription.subscription_type === 'ENTERPRISE';
    let display         = false;

    if (is_instant_paid || is_core || is_enterprise) {
      display = true;
    }

    return display;
  }

  updatePageState = (page_number, status) => {
    let page_state = this.props.instant && this.props.instant.instantPageState ? this.props.instant.instantPageState : { page_number: 1, status: 'COMPLETED' };
    page_state.page_number = page_number ? page_number : page_state.page_number;
    page_state.status      = status      ? status      : page_state.status;
    this.props.instantActions.updateInstantPageState(page_state);
  }

  getSessionsToDisplay = () => {
    let selected_status = this.state.selected_status;
    let sessions_dict   = this.props.instant && this.props.instant.instantSessions     ? this.props.instant.instantSessions     : {};
    let completed_ids   = this.props.instant && this.props.instant.completedSessionIds ? this.props.instant.completedSessionIds : [];
    let cancelled_ids   = this.props.instant && this.props.instant.cancelledSessionIds ? this.props.instant.cancelledSessionIds : [];
    let sessions        = [];
    let page_state      = this.props.instant && this.props.instant.instantPageState ? this.props.instant.instantPageState : { page_number: 1, status: 'COMPLETED' };
    let selected_ids    = page_state.status === 'COMPLETED' ? completed_ids : cancelled_ids;
    let page_number     = page_state.page_number;

    let total_count     = selected_ids.length;
    let count_per_page  = 6;
    let start_index     = (page_number - 1) * count_per_page;
    let end_index       = ((page_number * count_per_page) - 1) > total_count -1 ? total_count -1 : ((page_number * count_per_page) - 1);

    let display_next    = (page_number * count_per_page) < total_count ? true : false;
    let display_prev    = page_number > 1 ? true : false;

    let sub_array       = selected_ids.slice(start_index, end_index + 1);

    sub_array.forEach((session_id, i) => {
      let session = sessions_dict[session_id] || null;
      if (session) {
        sessions.push(session);
      }
    });

    let display_data = {
      display_next: display_next,
      display_prev: display_prev,
      sessions: sessions
    }

    return display_data;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    instant: state.instant,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantCompletedScreen)
